/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Rellax from "rellax";

/*------------------------------------*\
    PARALLAX
\*------------------------------------*/
class Parallax {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.speed = parseInt(self.elem.getAttribute('[data-parallax-speed]'));
    }

    init() {
        let self = this;

        const rellax = new Rellax(self.elem);
    }

}

export default Parallax;
